function basePdv(): string | null {
  const base = import.meta.env.VITE_URL_PDV as string | undefined
  if (!base) return null

  return base.replace(/\/+$/, '')
}

export function urlLoginPdv(): string | null {
  const base = basePdv()
  if (!base) return null

  return `${base}/login?logout=1`
}

export function urlTotemPareado(codigoTroca: string): string | null {
  const base = basePdv()
  if (!base) return null

  return `${base}/totem-pareado?troca=${encodeURIComponent(codigoTroca)}`
}

export function urlTrocarPontoTotem(): string | null {
  const base = basePdv()
  if (!base) return null

  return `${base}/totem/trocar`
}
